(function () {
  const WORKER_URL = 'https://shopify-r2-uploader.iprintsmiley.workers.dev';
  const MAX_SINGLE_UPLOAD_BYTES = 30 * 1024 * 1024;
  const MAX_TOTAL_BYTES = 30 * 1024 * 1024;

  const A2_PORTRAIT = [1190.55, 1683.78]; 
  const A2_LANDSCAPE = [1683.78, 1190.55];

  const isMobileDevice = window.matchMedia("(max-width: 768px)").matches || ('ontouchstart' in window);

  let firstTimeout = null;
  let removeTimeout = null;
  let secondBoxShown = false;

  let activeModalItem = null;
  let activeModalIndex = -1;
  let modalTempState = null;
  let isDragging = false;
  let startX = 0, startY = 0;

  if (window.pdfjsLib) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
  }

  function sanitizeFileName(file) {
    const lastDotIndex = file.name.lastIndexOf('.');
    const ext = lastDotIndex !== -1 ? file.name.substring(lastDotIndex) : '';
    const baseName = lastDotIndex !== -1 ? file.name.substring(0, lastDotIndex) : file.name;

    const cleanBaseName = baseName
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_+|_+$/g, '');

    return new File([file], (cleanBaseName || 'file') + ext.toLowerCase(), { type: file.type });
  }

  async function convertFileToPngBytes(file) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);
      
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth || img.width;
        canvas.height = img.naturalHeight || img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        canvas.toBlob((blob) => {
          URL.revokeObjectURL(url);
          if (!blob) {
            reject(new Error('Canvas blob conversion failed'));
            return;
          }
          blob.arrayBuffer().then(resolve).catch(reject);
        }, 'image/png');
      };

      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('Failed to load image for PDF embedding'));
      };

      img.src = url;
    });
  }

  function moveCartContainerToSuccessContainer() {
    const container = document.getElementById("added-to-cart-container");
    const targetContainer = document.querySelector(".success-cart-container");
    
    if (container && targetContainer) {
      if (container.parentNode !== targetContainer) {
        targetContainer.appendChild(container);
      }
    } else if (container && !targetContainer) {
      const productInfo = document.querySelector(".product-information");
      if (productInfo && container.parentNode !== productInfo.parentNode) {
        productInfo.parentNode.insertBefore(container, productInfo);
      }
    }
  }

  function showFirstCartBox() {
    moveCartContainerToSuccessContainer();

    const slot = document.getElementById("dynamic-box-slot");
    const dataStore = document.getElementById("i18n-data-store");
    if (!slot || !dataStore) return;

    const addedText = dataStore.dataset.addedText || "Added to cart";
    const viewCartText = dataStore.dataset.viewCartText || "View cart";
    const cartUrl = dataStore.dataset.cartUrl || "/cart";

    slot.innerHTML = "";

    const box = document.createElement("div");
    box.classList.add("added-box");

    box.innerHTML = `
      <img src="https://i.printsmiley.com/SVG/icons/shopping-cart_613524.svg" class="check-icon">
      ${addedText}<br>
      <a href="${cartUrl}" class="cart-btn">${viewCartText}</a>
    `;

    slot.appendChild(box);

    setTimeout(() => box.classList.add("show"), 10);

    firstTimeout = setTimeout(() => {
      box.classList.remove("show");

      removeTimeout = setTimeout(() => {
        box.remove();
      }, 500);

    }, 5000);
  }

  function showSecondCartBox() {
    moveCartContainerToSuccessContainer();

    const slot = document.getElementById("static-box-slot");
    const dataStore = document.getElementById("i18n-data-store");
    if (!slot || !dataStore) return;

    const continueText = dataStore.dataset.continueShoppingText || "Continue shopping";
    const featuredText = dataStore.dataset.featuredProductsText || "Featured products";
    const collectionUrl = dataStore.dataset.allProductsUrl || "/collections/all";

    slot.innerHTML = "";

    const second = document.createElement("div");
    second.classList.add("second-box");

    second.innerHTML = `
      <img src="https://i.printsmiley.com/SVG/icons/delivery-truck_6132560 1.svg" class="check-icon">
      ${continueText}<br>
      <a href="${collectionUrl}" class="second-btn">${featuredText}</a>
    `;

    slot.appendChild(second);

    setTimeout(() => second.classList.add("show"), 10);
  }

  function initPosterUploader() {
    const modalOverlay = document.getElementById('custom-preview-modal-overlay');
    if (modalOverlay && document.body.firstChild !== modalOverlay) {
      document.body.prepend(modalOverlay);
    }

    const dropZoneFront = document.getElementById('drop-zone-front');
    const btnInitialUpload = document.getElementById('btn-initial-upload');
    const frontInput = document.getElementById('front-file-upload');
    const addMoreInput = document.getElementById('add-more-file-upload');
    
    const fileInfoContainer = document.getElementById('file-info-container');
    const sizeLimitDisplay = document.getElementById('size-limit-display');

    const optionsContainer = document.getElementById('options-container');
    const pdfListContainer = document.getElementById('pdf-files-list-container');
    const customPrintNameField = document.getElementById('custom-print-name-field');

    const frontPdfSelector = document.getElementById('front-pdf-range-selector');
    const selectedPdfRangeTitle = document.getElementById('selected-pdf-range-title');
    const frontPdfFromInput = document.getElementById('front-pdf-page-from');
    const frontPdfToInput = document.getElementById('front-pdf-page-to');
    const frontPdfMaxInfo = document.getElementById('front-pdf-max-info');

    const radioPrintTypes = document.getElementsByName('print_type_option');
    const mediaContainer = document.querySelector('.product-information__media') || document.querySelector('[data-testid="product-information-media"]');

    const modalCloseBtn = document.getElementById('btn-close-modal-preview');
    const modalSaveBtn = document.getElementById('btn-save-modal-preview');
    const modalTitleText = document.getElementById('modal-title-text');
    const modalContent = document.getElementById('modal-preview-content');
    const modalViewport = document.getElementById('modal-crop-viewport');

    const btnModalOrientation = document.getElementById('btn-modal-orientation');
    const btnModalRotate = document.getElementById('btn-modal-rotate');
    const btnModalFitMode = document.getElementById('btn-modal-fitmode');
    const btnModalReset = document.getElementById('btn-modal-reset');

    const mainForm = document.querySelector('form[id*="BuyButtons-ProductForm"]') || document.querySelector('form[action*="/cart/add"]');
    if (!mainForm) return;

    const buyButtons = document.querySelectorAll('[type="submit"], [name="add"], .add-to-cart-button, [data-testid="standalone-add-to-cart"], .sticky-add-to-cart__button');

    let masterFilesRegistry = [];
    let activePdfId = null;

    let uploadedFilesList = [];
    let pagesList = [];

    const renderedCanvasCache = new Map();

    function closeModalWithoutSaving() {
      if (modalOverlay) {
        modalOverlay.style.display = 'none';
        modalContent.innerHTML = '';
        activeModalItem = null;
        activeModalIndex = -1;
        modalTempState = null;
      }
    }

    function saveModalChangesAndClose() {
      if (activeModalItem && modalTempState) {
        Object.assign(activeModalItem, modalTempState);
        
        if (activeModalItem.uid) {
          renderedCanvasCache.delete(activeModalItem.uid);
        }

        renderInteractiveGallery();
      }
      closeModalWithoutSaving();
    }

    if (modalOverlay) modalOverlay.addEventListener('click', closeModalWithoutSaving);
    if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeModalWithoutSaving);
    if (modalSaveBtn) modalSaveBtn.addEventListener('click', saveModalChangesAndClose);

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropZoneFront.addEventListener(eventName, preventDefaults, false);
    });
    function preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    ['dragenter', 'dragover'].forEach(eventName => {
      dropZoneFront.addEventListener(eventName, () => dropZoneFront.classList.add('dragover'), false);
    });
    ['dragleave', 'drop'].forEach(eventName => {
      dropZoneFront.addEventListener('dragleave', () => dropZoneFront.classList.remove('dragover'), false);
    });
    dropZoneFront.addEventListener('drop', (e) => {
      const dt = e.dataTransfer;
      if (dt.files.length > 0) {
        processIncomingFiles(Array.from(dt.files));
      }
    });

    function updateListSelectDropdown(sheetCount) {
      const dropdown = document.querySelector('select[name="options[list]"]');
      if (dropdown) {
        const options = Array.from(dropdown.options).map(o => parseInt(o.value)).filter(v => !isNaN(v));
        
        let targetValue = sheetCount;
        if (options.length > 0) {
          const maxOption = Math.max(...options);
          const minOption = Math.min(...options);
          
          if (targetValue > maxOption) targetValue = maxOption;
          if (targetValue < minOption) targetValue = minOption;
        }

        dropdown.value = String(targetValue);
        dropdown.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function getSelectedPrintType() {
      for (const radio of radioPrintTypes) {
        if (radio.checked) return radio.value;
      }
      return 'double';
    }

    function updateSizeLimitDisplay() {
      let totalBytes = pagesList.reduce((acc, p) => {
        if (p.pageSizeBytes) {
          return acc + p.pageSizeBytes;
        }
        const fileObj = p.fileRef || p.file;
        return acc + (fileObj ? fileObj.size : 0);
      }, 0);

      const mb = (totalBytes / (1024 * 1024)).toFixed(1);
      
      const labelText = sizeLimitDisplay ? (sizeLimitDisplay.dataset.label || "Total size:") : "Total size:";
      sizeLimitDisplay.textContent = `${labelText} ${mb} MB / 30 MB`;
      
      if (pagesList.length === 0 || totalBytes > MAX_TOTAL_BYTES) {
        if (totalBytes > MAX_TOTAL_BYTES) {
          sizeLimitDisplay.style.color = 'red';
        } else {
          sizeLimitDisplay.style.color = '#555';
        }
        buyButtons.forEach(btn => btn.style.setProperty('display', 'none', 'important'));
      } else {
        sizeLimitDisplay.style.color = '#555';
        buyButtons.forEach(btn => btn.style.removeProperty('display'));
      }
    }

    function calculateAndSync() {
      const totalPagesCount = pagesList.length;
      const printType = getSelectedPrintType();

      let sheetCount = totalPagesCount;
      if (printType === 'double') {
        sheetCount = Math.ceil(totalPagesCount / 2);
      }

      updateListSelectDropdown(sheetCount);
      updateSizeLimitDisplay();
    }

    function triggerDownloadFile(file) {
      const url = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }

    function updateUploadButtonsVisibility() {
      if (uploadedFilesList.length === 0) {
        btnInitialUpload.style.setProperty('display', 'inline-block', 'important');
        fileInfoContainer.style.display = 'none';
        optionsContainer.style.display = 'none';
      } else {
        btnInitialUpload.style.setProperty('display', 'none', 'important');
        fileInfoContainer.style.display = 'block';
        optionsContainer.style.display = 'block';
      }
    }

    async function processIncomingFiles(files) {
      if (!files || files.length === 0) return;

      let currentBytes = pagesList.reduce((acc, p) => acc + (p.pageSizeBytes || (p.fileRef ? p.fileRef.size : 0)), 0);

      for (let rawFile of files) {
        const file = sanitizeFileName(rawFile);

        if (currentBytes + file.size > MAX_TOTAL_BYTES) {
          alert(`File "${file.name}" exceeds 30 MB limit.`);
          continue;
        }

        currentBytes += file.size;
        uploadedFilesList.push(file);

        btnInitialUpload.style.display = 'none';
        fileInfoContainer.style.display = 'block';
        optionsContainer.style.display = 'block';

        const fileId = 'f_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5);

        if (file.type === 'application/pdf' && window.pdfjsLib) {
          const buffer = await file.arrayBuffer();
          const pdf = await pdfjsLib.getDocument(new Uint8Array(buffer)).promise;

          const pdfObj = {
            id: fileId,
            file: file,
            isPdf: true,
            pdfDoc: pdf,
            arrayBuffer: buffer,
            maxPages: pdf.numPages,
            fromPage: 1,
            toPage: pdf.numPages
          };

          masterFilesRegistry.push(pdfObj);
          activePdfId = fileId;

          const singlePageSizeBytes = file.size / pdf.numPages;

          for (let p = 1; p <= pdf.numPages; p++) {
            let isLandscape = false;
            try {
              const pdfPage = await pdf.getPage(p);
              const vp = pdfPage.getViewport({ scale: 1.0 });
              isLandscape = vp.width > vp.height;
            } catch (e) {}

            pagesList.push({
              uid: fileId + '_p_' + p + '_' + Math.random().toString(36).substr(2, 4),
              fileId: fileId,
              type: 'pdf',
              pageNum: p,
              fileName: file.name,
              pdfDoc: pdf,
              arrayBuffer: buffer,
              fileRef: file,
              pageSizeBytes: singlePageSizeBytes,
              rotation: 0,
              isLandscape: isLandscape,
              fitMode: 'contain',
              zoom: 1.0,
              offsetXPixels: 0,
              offsetYPixels: 0
            });
          }
        } else if (file.type.startsWith('image/')) {
          let isLandscape = false;
          await new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
              isLandscape = img.width > img.height;
              resolve();
            };
            img.onerror = resolve;
            img.src = URL.createObjectURL(file);
          });

          const imgObj = {
            id: fileId,
            file: file,
            isPdf: false
          };

          masterFilesRegistry.push(imgObj);

          pagesList.push({
            uid: 'img_' + fileId + '_' + Math.random().toString(36).substr(2, 4),
            fileId: fileId,
            type: 'image',
            fileName: file.name,
            file: file,
            fileRef: file,
            pageSizeBytes: file.size,
            rotation: 0,
            isLandscape: isLandscape,
            fitMode: 'contain',
            zoom: 1.0,
            offsetXPixels: 0,
            offsetYPixels: 0
          });
        }
      }

      renderFileListUI();
      renderInteractiveGallery();
      calculateAndSync();
    }

    function duplicateFileInRegistry(fileId) {
      const index = masterFilesRegistry.findIndex(f => f.id === fileId);
      if (index !== -1) {
        const original = masterFilesRegistry[index];
        const newId = 'f_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5);

        const copyObj = Object.assign({}, original, {
          id: newId,
          file: new File([original.file], original.file.name, { type: original.file.type })
        });

        uploadedFilesList.push(copyObj.file);
        masterFilesRegistry.splice(index + 1, 0, copyObj);

        processIncomingFiles([copyObj.file]);
      }
    }

    function renderFileListUI() {
      pdfListContainer.innerHTML = '';

      if (masterFilesRegistry.length === 0) {
        document.getElementById('pdf-list-section').style.display = 'none';
        frontPdfSelector.style.display = 'none';
        updateUploadButtonsVisibility();
        calculateAndSync();
        return;
      }

      document.getElementById('pdf-list-section').style.display = 'block';

      masterFilesRegistry.forEach(fileObj => {
        const item = document.createElement('div');
        item.className = 'uploaded-file-item' + (fileObj.id === activePdfId ? ' selected' : '');
        item.dataset.id = fileObj.id;

        const leftDiv = document.createElement('div');
        leftDiv.className = 'file-item-left';

        const handle = document.createElement('span');
        handle.className = 'drag-handle';
        handle.innerHTML = '⣿';

        const titleSpan = document.createElement('span');
        titleSpan.style.wordBreak = 'break-all';
        titleSpan.innerHTML = `${fileObj.isPdf ? '📄' : '🖼️'} <strong>${fileObj.file.name}</strong> ${fileObj.isPdf ? '<small style="color:#666;">(' + fileObj.maxPages + ' p.)</small>' : ''}`;

        leftDiv.appendChild(handle);
        leftDiv.appendChild(titleSpan);

        leftDiv.onclick = () => {
          if (fileObj.isPdf) {
            activePdfId = fileObj.id;
            renderFileListUI();
            showPdfRangeSelector(fileObj);
          }
        };

        const actionsDiv = document.createElement('div');
        actionsDiv.className = 'file-item-actions';

        const duplicateBtn = document.createElement('button');
        duplicateBtn.type = 'button';
        duplicateBtn.className = 'btn-action-icon-svg';
        duplicateBtn.title = 'Duplicate file';
        duplicateBtn.innerHTML = `
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        `;
        duplicateBtn.onclick = (e) => {
          e.stopPropagation();
          e.preventDefault();
          duplicateFileInRegistry(fileObj.id);
        };

        const deleteBtn = document.createElement('button');
        deleteBtn.type = 'button';
        deleteBtn.className = 'btn-action-delete-svg';
        deleteBtn.title = 'Delete file';
        deleteBtn.innerHTML = `
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        `;
        deleteBtn.onclick = (e) => {
          e.stopPropagation();
          e.preventDefault();
          deleteFileFromState(fileObj.id);
        };

        actionsDiv.appendChild(duplicateBtn);
        actionsDiv.appendChild(deleteBtn);
        item.appendChild(leftDiv);
        item.appendChild(actionsDiv);

        pdfListContainer.appendChild(item);
      });

      if (window.Sortable && !isMobileDevice) {
        Sortable.create(pdfListContainer, {
          animation: 150,
          handle: '.drag-handle',
          onEnd: function (evt) {
            const movedObj = masterFilesRegistry.splice(evt.oldIndex, 1)[0];
            masterFilesRegistry.splice(evt.newIndex, 0, movedObj);
          }
        });
      }

      const currentActive = masterFilesRegistry.find(p => p.id === activePdfId && p.isPdf);
      if (currentActive) {
        showPdfRangeSelector(currentActive);
      } else {
        frontPdfSelector.style.display = 'none';
      }

      updateUploadButtonsVisibility();
    }

    function deleteFileFromState(fileId) {
      const foundIndex = masterFilesRegistry.findIndex(p => p.id === fileId);
      if (foundIndex !== -1) {
        const fileToRemove = masterFilesRegistry[foundIndex].file;
        
        uploadedFilesList = uploadedFilesList.filter(f => f !== fileToRemove);
        masterFilesRegistry.splice(foundIndex, 1);

        pagesList.forEach(p => {
          if (p.fileId === fileId && p.uid) {
            renderedCanvasCache.delete(p.uid);
          }
        });

        pagesList = pagesList.filter(p => p.fileId !== fileId);

        if (activePdfId === fileId) {
          const nextPdf = masterFilesRegistry.find(f => f.isPdf);
          activePdfId = nextPdf ? nextPdf.id : null;
        }

        renderFileListUI();
        renderInteractiveGallery();
        calculateAndSync();
      }
    }

    function showPdfRangeSelector(pdfObj) {
      frontPdfSelector.style.display = 'block';
      frontPdfFromInput.value = pdfObj.fromPage;
      frontPdfToInput.value = pdfObj.toPage;
      frontPdfFromInput.max = pdfObj.maxPages;
      frontPdfToInput.max = pdfObj.maxPages;
      frontPdfMaxInfo.textContent = `(${pdfObj.maxPages} p.)`;
    }

    // 🟢 PRACUJE S PŘESNÝM VIZUÁLNÍM PROHODINOVÝM ROZMĚREM PRO ROTACI 90/270 A ZACHOVÁVÁ BÍLÉ PRUHY
    async function generateFinalCompiledPdfBlob() {
      const { PDFDocument, degrees } = PDFLib;
      const compiledPdf = await PDFDocument.create();

      for (let item of pagesList) {
        const rot = (360 - ((item.rotation || 0) % 360)) % 360; 
        const is90or270 = rot === 90 || rot === 270;
        
        const targetA2Size = item.isLandscape ? A2_LANDSCAPE : A2_PORTRAIT;
        const a2Width = targetA2Size[0];
        const a2Height = targetA2Size[1];

        const newPage = compiledPdf.addPage([a2Width, a2Height]);

        const vpWidth = item.isLandscape ? 534.6 : 378;
        const vpHeight = item.isLandscape ? 378 : 534.6;

        let origWidth, origHeight, embedObject;

        if (item.type === 'pdf' && item.arrayBuffer) {
          const srcPdf = await PDFDocument.load(item.arrayBuffer);
          const [embeddedPage] = await compiledPdf.embedPdf(srcPdf, [item.pageNum - 1]);
          origWidth = embeddedPage.width;
          origHeight = embeddedPage.height;
          embedObject = embeddedPage;
        } else if (item.type === 'image' && item.file) {
          const pngBytes = await convertFileToPngBytes(item.file);
          const embeddedImage = await compiledPdf.embedPng(pngBytes);
          origWidth = embeddedImage.width;
          origHeight = embeddedImage.height;
          embedObject = embeddedImage;
        }

        if (embedObject) {
          // Při rotaci o 90/270 se fyzicky prohodí šířka s výškou v A2 prostoru
          const visWidth = is90or270 ? origHeight : origWidth;
          const visHeight = is90or270 ? origWidth : origHeight;

          let baseScale = 1.0;
          if (item.fitMode === 'contain') {
            baseScale = Math.min(a2Width / visWidth, a2Height / visHeight);
          } else {
            baseScale = Math.max(a2Width / visWidth, a2Height / visHeight);
          }

          const finalScale = baseScale * (item.zoom || 1.0);
          
          const drawWidth = origWidth * finalScale;
          const drawHeight = origHeight * finalScale;

          const oxPoints = ((item.offsetXPixels || 0) / vpWidth) * a2Width;
          const oyPoints = ((item.offsetYPixels || 0) / vpHeight) * a2Height;

          const cx = a2Width / 2 + oxPoints;
          const cy = a2Height / 2 - oyPoints;

          const rad = rot * Math.PI / 180;
          const vx = (drawWidth / 2) * Math.cos(rad) - (drawHeight / 2) * Math.sin(rad);
          const vy = (drawWidth / 2) * Math.sin(rad) + (drawHeight / 2) * Math.cos(rad);

          const posX = cx - vx;
          const posY = cy - vy;

          if (item.type === 'pdf') {
            newPage.drawPage(embedObject, {
              x: posX,
              y: posY,
              xScale: finalScale,
              yScale: finalScale,
              rotate: degrees(rot)
            });
          } else {
            newPage.drawImage(embedObject, {
              x: posX,
              y: posY,
              width: drawWidth,
              height: drawHeight,
              rotate: degrees(rot)
            });
          }
        }
      }

      const compiledPdfBytes = await compiledPdf.save();
      return new Blob([compiledPdfBytes], { type: 'application/pdf' });
    }

    async function downloadCompiledPDF() {
      if (pagesList.length === 0) return;

      try {
        const compiledBlob = await generateFinalCompiledPdfBlob();
        const compiledFile = new File([compiledBlob], 'compiled_print_document_A2.pdf', { type: 'application/pdf' });
        triggerDownloadFile(compiledFile);
      } catch (err) {
        alert('Error compiling PDF: ' + err.message);
      }
    }

    function movePagePosition(currentIndex, newIndex) {
      if (newIndex < 0 || newIndex >= pagesList.length) return;
      const item = pagesList.splice(currentIndex, 1)[0];
      pagesList.splice(newIndex, 0, item);
      renderInteractiveGallery();
    }

    function duplicateSinglePageCard(index) {
      if (index < 0 || index >= pagesList.length) return;
      const originalItem = pagesList[index];

      const copyItem = Object.assign({}, originalItem, {
        uid: originalItem.fileId + '_p_' + originalItem.pageNum + '_dup_' + Math.random().toString(36).substr(2, 4)
      });

      if (originalItem.fileRef) {
        uploadedFilesList.push(originalItem.fileRef);
      } else if (originalItem.file) {
        uploadedFilesList.push(originalItem.file);
      }

      pagesList.splice(index + 1, 0, copyItem);
      
      renderInteractiveGallery();
      calculateAndSync();
    }

    function applyTransformToElement(mediaEl, state, isCard = false) {
      if (!mediaEl || !state) return;
      const zoom = state.zoom || 1.0;
      const rot = state.rotation || 0;
      let oxPx = state.offsetXPixels || 0;
      let oyPx = state.offsetYPixels || 0;

      if (isCard) {
        const cardScale = 140 / 378;
        oxPx *= cardScale;
        oyPx *= cardScale;
      }

      mediaEl.style.transform = `translate(${oxPx}px, ${oyPx}px) rotate(${rot}deg) scale(${zoom})`;
    }

    function updateModalContainerClasses() {
      if (!modalViewport || !modalTempState) return;
      const modalContentWrapper = document.getElementById('modal-preview-content');

      const is90or270 = (modalTempState.rotation || 0) === 90 || (modalTempState.rotation || 0) === 270;
      const effectiveLandscape = is90or270 ? !modalTempState.isLandscape : modalTempState.isLandscape;

      if (effectiveLandscape) {
        modalViewport.classList.add('is-landscape');
      } else {
        modalViewport.classList.remove('is-landscape');
      }

      if (modalTempState.fitMode === 'cover') {
        modalViewport.classList.add('mode-cover');
        modalViewport.classList.remove('mode-contain');
        if (modalContentWrapper) {
          modalContentWrapper.classList.add('mode-cover');
          modalContentWrapper.classList.remove('mode-contain');
        }
      } else {
        modalViewport.classList.add('mode-contain');
        modalViewport.classList.remove('mode-cover');
        if (modalContentWrapper) {
          modalContentWrapper.classList.add('mode-contain');
          modalContentWrapper.classList.remove('mode-cover');
        }
      }
    }

    async function openModalZoomPreview(item, globalIndex) {
      activeModalItem = item;
      activeModalIndex = globalIndex - 1;

      modalTempState = {
        zoom: item.zoom || 1.0,
        rotation: item.rotation || 0,
        offsetXPixels: item.offsetXPixels || 0,
        offsetYPixels: item.offsetYPixels || 0,
        isLandscape: item.isLandscape || false,
        fitMode: item.fitMode || 'contain'
      };

      modalContent.innerHTML = '';
      modalTitleText.textContent = `${globalIndex} - ${item.fileName} ${item.type === 'pdf' ? '(Page ' + item.pageNum + ')' : ''}`;

      updateModalContainerClasses();

      let mediaElem = null;

      if (item.type === 'pdf' && item.pdfDoc) {
        const page = await item.pdfDoc.getPage(item.pageNum);
        const viewport = page.getViewport({ scale: 2.2 });

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        modalContent.appendChild(canvas);

        await page.render({
          canvasContext: context,
          viewport: viewport
        }).promise;

        mediaElem = canvas;
      } else if (item.file) {
        const img = document.createElement('img');
        img.src = URL.createObjectURL(item.file);
        modalContent.appendChild(img);
        mediaElem = img;
      }

      if (mediaElem) {
        applyTransformToElement(mediaElem, modalTempState, false);
      }

      modalOverlay.style.display = 'flex';
    }

    modalViewport.addEventListener('wheel', (e) => {
      if (!modalTempState) return;
      e.preventDefault();
      
      const delta = e.deltaY < 0 ? 0.1 : -0.1;
      modalTempState.zoom = Math.min(Math.max((modalTempState.zoom || 1.0) + delta, 0.5), 5.0);

      const mediaEl = modalContent.querySelector('canvas') || modalContent.querySelector('img');
      applyTransformToElement(mediaEl, modalTempState, false);
    });

    modalViewport.addEventListener('mousedown', (e) => {
      if (!modalTempState) return;
      isDragging = true;
      startX = e.clientX - (modalTempState.offsetXPixels || 0);
      startY = e.clientY - (modalTempState.offsetYPixels || 0);
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging || !modalTempState) return;

      modalTempState.offsetXPixels = e.clientX - startX;
      modalTempState.offsetYPixels = e.clientY - startY;

      const mediaEl = modalContent.querySelector('canvas') || modalContent.querySelector('img');
      applyTransformToElement(mediaEl, modalTempState, false);
    });

    window.addEventListener('mouseup', () => {
      if (isDragging) {
        isDragging = false;
      }
    });

    if (btnModalOrientation) {
      btnModalOrientation.onclick = () => {
        if (!modalTempState) return;
        modalTempState.isLandscape = !modalTempState.isLandscape;
        
        modalTempState.offsetXPixels = 0;
        modalTempState.offsetYPixels = 0;
        
        updateModalContainerClasses();

        const mediaEl = modalContent.querySelector('canvas') || modalContent.querySelector('img');
        applyTransformToElement(mediaEl, modalTempState, false);
      };
    }

    if (btnModalRotate) {
      btnModalRotate.onclick = () => {
        if (!modalTempState) return;
        modalTempState.rotation = ((modalTempState.rotation || 0) + 90) % 360;
        updateModalContainerClasses();

        const mediaEl = modalContent.querySelector('canvas') || modalContent.querySelector('img');
        applyTransformToElement(mediaEl, modalTempState, false);
      };
    }

    if (btnModalFitMode) {
      btnModalFitMode.onclick = () => {
        if (!modalTempState) return;
        modalTempState.fitMode = modalTempState.fitMode === 'cover' ? 'contain' : 'cover';
        updateModalContainerClasses();

        const mediaEl = modalContent.querySelector('canvas') || modalContent.querySelector('img');
        applyTransformToElement(mediaEl, modalTempState, false);
      };
    }

    if (btnModalReset) {
      btnModalReset.onclick = () => {
        if (!modalTempState) return;
        modalTempState.zoom = 1.0;
        modalTempState.offsetXPixels = 0;
        modalTempState.offsetYPixels = 0;
        modalTempState.fitMode = 'contain';
        updateModalContainerClasses();

        const mediaEl = modalContent.querySelector('canvas') || modalContent.querySelector('img');
        applyTransformToElement(mediaEl, modalTempState, false);
      };
    }

    async function renderInteractiveGallery() {
      if (!mediaContainer) return;

      let galleryWrapper = mediaContainer.querySelector('.custom-pdf-preview-gallery');
      if (!galleryWrapper) {
        galleryWrapper = document.createElement('div');
        galleryWrapper.className = 'custom-pdf-preview-gallery';
        mediaContainer.prepend(galleryWrapper);
      }

      galleryWrapper.innerHTML = '';

      if (pagesList.length === 0) {
        calculateAndSync();
        updateUploadButtonsVisibility();
        return;
      }

      const topToolbar = document.createElement('div');
      topToolbar.className = 'gallery-top-toolbar';

      const dataStore = document.getElementById('i18n-data-store');
      const downloadText = dataStore ? (dataStore.dataset.downloadPdf || "PDF") : "PDF";

      const btnDownloadCompiled = document.createElement('button');
      btnDownloadCompiled.type = 'button';
      btnDownloadCompiled.className = 'btn-download-compiled';
      btnDownloadCompiled.innerHTML = downloadText;
      btnDownloadCompiled.onclick = downloadCompiledPDF;

      topToolbar.appendChild(btnDownloadCompiled);
      galleryWrapper.appendChild(topToolbar);

      for (let i = 0; i < pagesList.length; i++) {
        const item = pagesList[i];
        const globalOrderIndex = i + 1;

        const wrapper = document.createElement('div');
        wrapper.className = 'page-preview-card-wrapper';
        wrapper.dataset.index = i;

        const is90or270 = item.rotation === 90 || item.rotation === 270;
        const effectiveLandscape = is90or270 ? !item.isLandscape : item.isLandscape;

        const card = document.createElement('div');
        card.className = 'page-preview-card' + (effectiveLandscape ? ' is-landscape' : '');
        card.onclick = () => openModalZoomPreview(item, globalOrderIndex);

        const header = document.createElement('div');
        header.className = 'page-card-header';
        
        header.innerHTML = `
          <div style="display: flex; align-items: center; gap: 6px; overflow: hidden;">
            <span class="drag-handle">⣿</span>
            <span class="short-pagenum-title">${globalOrderIndex}</span>
          </div>
        `;

        const actions = document.createElement('div');
        actions.className = 'card-actions';

        const zoomBtn = document.createElement('button');
        zoomBtn.className = 'btn-zoom-page';
        zoomBtn.innerHTML = '🔍';
        zoomBtn.title = 'Zoom & Crop';
        zoomBtn.onclick = (e) => {
          e.stopPropagation();
          e.preventDefault();
          openModalZoomPreview(item, globalOrderIndex);
        };

        const duplicateCardBtn = document.createElement('button');
        duplicateCardBtn.className = 'btn-duplicate-page';
        duplicateCardBtn.innerHTML = '📋';
        duplicateCardBtn.title = 'Duplicate page';
        duplicateCardBtn.onclick = (e) => {
          e.stopPropagation();
          e.preventDefault();
          duplicateSinglePageCard(i);
        };

        const removeBtn = document.createElement('button');
        removeBtn.className = 'btn-remove-page-orange';
        removeBtn.title = 'Remove page';
        removeBtn.innerHTML = `
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        `;
        removeBtn.onclick = (e) => {
          e.stopPropagation();
          e.preventDefault();

          const fileIdToRemove = pagesList[i].fileId;
          pagesList.splice(i, 1);

          const hasMorePagesFromSameFile = pagesList.some(p => p.fileId === fileIdToRemove);
          if (!hasMorePagesFromSameFile) {
            masterFilesRegistry = masterFilesRegistry.filter(f => f.id !== fileIdToRemove);
            renderFileListUI();
          }

          renderInteractiveGallery();
          calculateAndSync();
        };

        actions.appendChild(zoomBtn);
        actions.appendChild(duplicateCardBtn);
        actions.appendChild(removeBtn);
        header.appendChild(actions);
        card.appendChild(header);

        const mediaWrapper = document.createElement('div');
        mediaWrapper.className = 'card-media-wrapper ' + (item.fitMode === 'cover' ? 'mode-cover' : 'mode-contain');

        let mediaEl = null;

        if (item.type === 'pdf' && item.pdfDoc) {
          if (renderedCanvasCache.has(item.uid)) {
            const cachedCanvas = renderedCanvasCache.get(item.uid);
            const cloneCanvas = document.createElement('canvas');
            cloneCanvas.width = cachedCanvas.width;
            cloneCanvas.height = cachedCanvas.height;
            const ctx = cloneCanvas.getContext('2d');
            ctx.drawImage(cachedCanvas, 0, 0);
            mediaWrapper.appendChild(cloneCanvas);
            mediaEl = cloneCanvas;
          } else {
            try {
              const page = await item.pdfDoc.getPage(item.pageNum);
              const viewport = page.getViewport({ scale: 1.5 });

              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              mediaWrapper.appendChild(canvas);

              await page.render({
                canvasContext: context,
                viewport: viewport
              }).promise;

              renderedCanvasCache.set(item.uid, canvas);
              mediaEl = canvas;
            } catch (err) {
              console.error('Render page error:', err);
            }
          }
        } else if (item.file) {
          const img = document.createElement('img');
          img.src = URL.createObjectURL(item.file);
          mediaWrapper.appendChild(img);
          mediaEl = img;
        }

        if (mediaEl) {
          applyTransformToElement(mediaEl, item, true);
        }

        card.appendChild(mediaWrapper);

        const mobileActions = document.createElement('div');
        mobileActions.className = 'mobile-move-actions';

        const btnLeft = document.createElement('button');
        btnLeft.type = 'button';
        btnLeft.className = 'btn-move-arrow-svg';
        btnLeft.title = 'Move left';
        btnLeft.disabled = i === 0;
        btnLeft.innerHTML = `
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        `;
        btnLeft.onclick = (e) => {
          e.stopPropagation();
          e.preventDefault();
          movePagePosition(i, i - 1);
        };

        const btnRight = document.createElement('button');
        btnRight.type = 'button';
        btnRight.className = 'btn-move-arrow-svg';
        btnRight.title = 'Move right';
        btnRight.disabled = i === pagesList.length - 1;
        btnRight.innerHTML = `
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        `;
        btnRight.onclick = (e) => {
          e.stopPropagation();
          e.preventDefault();
          movePagePosition(i, i + 1);
        };

        mobileActions.appendChild(btnLeft);
        mobileActions.appendChild(btnRight);
        card.appendChild(mobileActions);

        wrapper.appendChild(card);
        galleryWrapper.appendChild(wrapper);
      }

      if (window.Sortable && !isMobileDevice) {
        Sortable.create(galleryWrapper, {
          animation: 150,
          draggable: '.page-preview-card-wrapper',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          onEnd: function (evt) {
            const wrappers = Array.from(galleryWrapper.querySelectorAll('.page-preview-card-wrapper'));
            const newPagesList = [];
            wrappers.forEach(w => {
              const oldIndex = parseInt(w.dataset.index);
              if (!isNaN(oldIndex) && pagesList[oldIndex]) {
                newPagesList.push(pagesList[oldIndex]);
              }
            });
            
            if (newPagesList.length === pagesList.length) {
              pagesList = newPagesList;
              renderInteractiveGallery();
            }
          }
        });
      }

      calculateAndSync();
      updateUploadButtonsVisibility();
    }

    function updateActivePdfPagesFromRange() {
      if (!activePdfId) return;

      const pdfObj = masterFilesRegistry.find(p => p.id === activePdfId && p.isPdf);
      if (!pdfObj) return;

      let from = parseInt(frontPdfFromInput.value) || 1;
      let to = parseInt(frontPdfToInput.value) || 1;

      if (from < 1) from = 1;
      if (to > pdfObj.maxPages) to = pdfObj.maxPages;
      if (from > to) from = to;

      pdfObj.fromPage = from;
      pdfObj.toPage = to;

      pagesList = pagesList.filter(p => p.fileId !== activePdfId);

      const singlePageSizeBytes = pdfObj.file.size / pdfObj.maxPages;

      for (let p = from; p <= to; p++) {
        pagesList.push({
          uid: pdfObj.id + '_p_' + p + '_' + Math.random().toString(36).substr(2, 4),
          fileId: pdfObj.id,
          type: 'pdf',
          pageNum: p,
          fileName: pdfObj.file.name,
          pdfDoc: pdfObj.pdfDoc,
          arrayBuffer: pdfObj.arrayBuffer,
          fileRef: pdfObj.file,
          pageSizeBytes: singlePageSizeBytes,
          rotation: 0,
          isLandscape: false,
          fitMode: 'contain',
          zoom: 1.0,
          offsetXPixels: 0,
          offsetYPixels: 0
        });
      }

      renderInteractiveGallery();
      calculateAndSync();
    }

    frontInput.addEventListener('change', function() {
      if (this.files) processIncomingFiles(Array.from(this.files));
    });

    addMoreInput.addEventListener('change', function() {
      if (this.files) processIncomingFiles(Array.from(this.files));
    });

    frontPdfFromInput.addEventListener('input', updateActivePdfPagesFromRange);
    frontPdfToInput.addEventListener('input', updateActivePdfPagesFromRange);

    radioPrintTypes.forEach(radio => {
      radio.addEventListener('change', function() {
        document.querySelectorAll('.print-mode-toggle label').forEach(lbl => lbl.classList.remove('active'));
        this.closest('label').classList.add('active');
        calculateAndSync();
      });
    });

    async function uploadCompiledFileToR2(fileToUpload) {
      const formData = new FormData();
      formData.append('file', fileToUpload);

      const response = await fetch(WORKER_URL, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();
      if (!response.ok || data.error) {
        throw new Error(data.error || 'Upload to R2 failed.');
      }

      return data.fileUrl;
    }

    mainForm.addEventListener('submit', async function (e) {
      if (pagesList.length === 0) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        alert('Please upload a file to print first.');
        return false;
      }

      e.preventDefault();

      const selectedVariantInput = mainForm.querySelector('[name="id"]');
      if (!selectedVariantInput || !selectedVariantInput.value) {
        alert('Error: Variant ID not found.');
        return;
      }

      const submitBtn = mainForm.querySelector('[type="submit"], [name="add"]');
      let originalText = '';
      if (submitBtn) {
        submitBtn.disabled = true;
        originalText = submitBtn.textContent;
        
        const dataStore = document.getElementById('i18n-data-store');
        submitBtn.textContent = dataStore ? (dataStore.dataset.uploadingPdf || 'Creating PDF & Uploading...') : 'Creating PDF & Uploading...';
      }

      try {
        const compiledBlob = await generateFinalCompiledPdfBlob();
        let finalFileToUpload = new File([compiledBlob], 'print_document_A2.pdf', { type: 'application/pdf' });

        if (finalFileToUpload.size > MAX_SINGLE_UPLOAD_BYTES) {
          const sizeMB = (finalFileToUpload.size / (1024 * 1024)).toFixed(1);
          throw new Error(`File is too large (${sizeMB} MB). Maximum allowed size for upload is 30 MB.`);
        }

        const uploadedUrl = await uploadCompiledFileToR2(finalFileToUpload);

        const printType = getSelectedPrintType();
        const sheetCount = printType === 'double' ? Math.ceil(pagesList.length / 2) : pagesList.length;

        const customPrintName = (customPrintNameField && customPrintNameField.value.trim() !== '') 
          ? customPrintNameField.value.trim() 
          : (pagesList[0] ? pagesList[0].fileName : 'Print Document');

        const cartProperties = {
          'Print Name': customPrintName,
          'Front Page': uploadedUrl,
          'Total Printed Pages': pagesList.length,
          'Paper Sheets': sheetCount,
          'Print Type': printType === 'double' ? 'Double-sided' : 'Single-sided'
        };

        const itemsData = [
          {
            id: selectedVariantInput.value,
            quantity: 1,
            properties: cartProperties
          }
        ];

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsData })
        });

        if (response.ok) {
          if (submitBtn) {
            const dataStore = document.getElementById('i18n-data-store');
            const btnAddedText = dataStore ? (dataStore.dataset.btnAddedToCart || '✓ Added to Cart!') : '✓ Added to Cart!';
            
            submitBtn.textContent = btnAddedText;
            setTimeout(() => {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
            }, 2500);
          }

          window.scrollTo({ top: 0, behavior: "smooth" });

          if (!secondBoxShown) {
            showSecondCartBox();
            secondBoxShown = true;
          }

          showFirstCartBox();

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } else {
          const errData = await response.json();
          alert('Error adding to cart: ' + (errData.description || errData.message || 'Unknown error'));
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        }
      } catch (err) {
        console.error('Error in pdf assembly/upload process:', err);
        alert('Upload Error: ' + err.message);

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }

        updateUploadButtonsVisibility();
      }
    });

    updateUploadButtonsVisibility();
    calculateAndSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPosterUploader);
  } else {
    initPosterUploader();
  }
})();